import appReports from "../../views/appSettings/reports.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "reports";
  const params = ["page", "limit", "type"];

  $stateProvider.state("reports", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appReports,
      },
    },
    reloadOnSearch: true,
    data: { title: "Reports" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/reports/reports.urls.js